import React, { useContext, useState } from 'react'
import { Collapse, Nav, Button } from 'react-bootstrap';
import { Context } from '../Context/DataContext';
import { AppColors } from '../css/AppColors';
import '../css/sb-admin-2.min.css'

import { useHistory } from 'react-router';



const useForceUpdate = () => {
  const [, updateState] = React.useState();
  return React.useCallback(() => updateState({}), []);
}



const Topbar = () => {

  const { state, setCustomersGlobal, setProductsGlobal, setStoreData, setManufactursGlobal } = useContext(Context)
  const [openIn, setOpenIn] = useState(false)
  // const forceUpdate = useForceUpdate()

  const history = useHistory();

  return (
    <Nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
      {/* Sidebar Toggle (Topbar) */}
      <button
        id="sidebarToggleTop"
        className="btn btn-link d-md-none rounded-circle mr-3"
      >
        <i className="fa fa-bars" />
      </button>
      {/* Topbar Search 
    <form class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
      <div class="input-group">
        <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2">
        <div class="input-group-append">
          <button class="btn btn-primary" type="button">
            <i class="fas fa-search fa-sm"></i>
          </button>
        </div>
      </div>
    </form> 

    <!-- Topbar Navbar */}
      <ul className="navbar-nav ml-auto">
        {/* Nav Item - Search Dropdown (Visible Only XS) */}
        <li className="nav-item dropdown no-arrow d-sm-none">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="searchDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i className="fas fa-search fa-fw" />
          </a>
          {/* Dropdown - Messages */}
          <div
            className="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
            aria-labelledby="searchDropdown"
          >
            <form className="form-inline mr-auto w-100 navbar-search">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control bg-light border-0 small"
                  placeholder="Search for..."
                  aria-label="Search"
                  aria-describedby="basic-addon2"
                />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm" />
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li>
        {/* Nav Item - Alerts */}
        {/* Nav Item - Messages */}
        <div className="topbar-divider d-none d-sm-block" />
        {/* Nav Item - User Information */}
        <li className="nav-item dropdown no-arrow">
          <a
            className="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="mr-2 d-none d-lg-inline text-gray-600 small">
              {/*?php print($_SESSION["st_name"]); ?*/}
            </span>
            <Button
              onClick={() => { setOpenIn(!openIn) }}
              className="rBBtn"

              style={{ fontFamily: 'PBo', borderWidth: 0, fontSize: 16, backgroundColor: AppColors.primary, color: 'white', letterSpacing: 0.5 }}
            >
              {state?.storeData?.st_name}
            </Button>
            {/* <img className="img-profile rounded-circle" src={profilePic} /> */}
          </a>
          {/* Dropdown - User Information */}
          <Collapse in={openIn} >
            <div
              className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
              aria-labelledby="userDropdown"
            >
              <a className="dropdown-item" >
                <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400" />
                Profile
              </a>
              {/* <a className="dropdown-item" href="#">
                <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400" />
                Settings
              </a>
              <a className="dropdown-item" href="#">
                <i className="fas fa-list fa-sm fa-fw mr-2 text-gray-400" />
                Activity Log
              </a> */}
              <div className="dropdown-divider" />
              <Button
                onClick={() => {
                  localStorage.removeItem('store_data');
                  setCustomersGlobal([]);
                  setProductsGlobal([]);
                  setStoreData([]);
                  setManufactursGlobal([])

                  history.push('/')
                }}
                className="dropdown-item"
                data-toggle="modal"
                data-target="#logoutModal"
              >
                <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                Logout
              </Button>
            </div>
          </Collapse>
        </li>
      </ul>
    </Nav>


  )
}

export default Topbar
